// The schema `class: "homepage-slider"` sits on the section *wrapper* (#shopify-section-…),
// while the banner settings (data-hero-order / data-hero-start) are on the inner
// `.hero-26`. Read the dataset from the inner element, falling back to the wrapper.
const heroData = element => (element.querySelector('.hero-26') || element).dataset;

// Read a banner's "Position in slider" setting. Missing/blank orders sort to the
// end (Infinity) so an unordered banner never steals the first slot.
const getHeroOrder = element => {
  const order = parseInt(heroData(element).heroOrder, 10);
  return Number.isNaN(order) ? Infinity : order;
};

const heroSlider = () => {
  const sliderElements = document.querySelectorAll('.homepage-slider');

  if (sliderElements.length > 1) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('homepage-slider-wrapper');

    // Get the first element's parent.
    const parent = sliderElements[0].parentNode;

    // Insert the new wrapper *before* the first element.
    parent.insertBefore(wrapper, sliderElements[0]);

    // Order the slides by their "Position in slider" setting before appending, so
    // the banner set to 1 shows first regardless of section order in the template.
    const orderedElements = Array.from(sliderElements).sort(
      (a, b) => getHeroOrder(a) - getHeroOrder(b)
    );

    // Add the elements into the wrapper
    orderedElements.forEach(element => {
      wrapper.appendChild(element);
    });

    // Open the carousel on the banner ticked as "Start slider on this banner".
    // Position order (and the H1 on position 1) is unchanged — this only sets
    // which slide is active on load. Defaults to the first slide if none ticked.
    const startIndex = orderedElements.findIndex(
      element => heroData(element).heroStart === 'true'
    );
    const initialSlide = startIndex < 0 ? 0 : startIndex;

    // Init slick
    $('.homepage-slider-wrapper').slick({
      autoplay: true,
      autoplaySpeed: 6000,
      dots: true,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      initialSlide: initialSlide,
    });
  }
};

export { heroSlider };
